import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89ee7222"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-msg-box-root" }
const _hoisted_2 = { class: "message-msg-box-wrap" }
const _hoisted_3 = { class: "message-msgbox-title-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "投注记录", -1))
const _hoisted_5 = { class: "message-body-wrap" }
const _hoisted_6 = { class: "form" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "时间", -1))
const _hoisted_8 = { class: "input-date-group" }
const _hoisted_9 = { class: "input-date" }
const _hoisted_10 = ["value", "disabled"]
const _hoisted_11 = { class: "drop-down-icon" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "至", -1))
const _hoisted_13 = { class: "input-date" }
const _hoisted_14 = ["value", "disabled"]
const _hoisted_15 = { class: "drop-down-icon" }
const _hoisted_16 = {
  key: 0,
  class: "records"
}
const _hoisted_17 = { class: "table-header" }
const _hoisted_18 = { class: "c1" }
const _hoisted_19 = { class: "c2" }
const _hoisted_20 = { class: "c3" }
const _hoisted_21 = { class: "c4" }
const _hoisted_22 = { class: "c5" }
const _hoisted_23 = { class: "c6" }
const _hoisted_24 = { class: "c7" }
const _hoisted_25 = { class: "c8" }
const _hoisted_26 = { class: "table-body" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "c1" }
const _hoisted_29 = { class: "c2" }
const _hoisted_30 = { class: "c3" }
const _hoisted_31 = { class: "c4" }
const _hoisted_32 = { class: "c5" }
const _hoisted_33 = { class: "c6" }
const _hoisted_34 = { class: "c7" }
const _hoisted_35 = { class: "c8" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 1,
  class: "no-data"
}
const _hoisted_38 = {
  key: 1,
  class: "records"
}
const _hoisted_39 = { class: "table-header" }
const _hoisted_40 = { class: "b1" }
const _hoisted_41 = { class: "b2" }
const _hoisted_42 = { class: "b3" }
const _hoisted_43 = { class: "b4" }
const _hoisted_44 = { class: "b5" }
const _hoisted_45 = { class: "b6" }
const _hoisted_46 = { class: "b7" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "b8" }, "视频", -1))
const _hoisted_48 = { class: "table-body" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "b1" }
const _hoisted_51 = { class: "b2" }
const _hoisted_52 = { class: "b3" }
const _hoisted_53 = { class: "b4" }
const _hoisted_54 = { class: "b5" }
const _hoisted_55 = { class: "b6" }
const _hoisted_56 = { class: "b7" }
const _hoisted_57 = { class: "b8" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 1,
  class: "no-data"
}
const _hoisted_60 = {
  key: 0,
  class: "video-content"
}
const _hoisted_61 = {
  autoplay: "",
  controls: ""
}
const _hoisted_62 = ["src"]
const _hoisted_63 = ["src"]
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Video Can not be played ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_arrow = _resolveComponent("icon-arrow")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_v_date_picker, {
            class: "form-item calendar-picker",
            "is-range": "",
            modelValue: _ctx.dateValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateValue) = $event)),
            columns: 2,
            locale: "zh-cn",
            masks: _ctx.masks,
            "min-date": _ctx.minDate()
          }, {
            default: _withCtx(({ inputValue, inputEvents }) => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("input", _mergeProps({
                    type: "text",
                    readonly: "",
                    value: inputValue.start
                  }, _toHandlers(inputEvents.start), { disabled: _ctx.isDetailView }), null, 16, _hoisted_10),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_icon_arrow)
                  ])
                ]),
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("input", _mergeProps({
                    type: "text",
                    readonly: "",
                    value: inputValue.end
                  }, _toHandlers(inputEvents.end), { disabled: _ctx.isDetailView }), null, 16, _hoisted_14),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_icon_arrow)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "masks", "min-date"]),
          _createElementVNode("div", {
            class: _normalizeClass(["form-item btn", { off: _ctx.isDetailView }]),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)))
          }, " 查询 ", 2)
        ]),
        (!_ctx.isDetailView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t('time')), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t('count')), 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t('totalinvest')), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.t('totalwin')), 1),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.t('wsbettingfee')), 1),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.t('codewashfee')), 1),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.t('summary')), 1),
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.t('details')), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                (_ctx.betLogs.length > 0)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_27, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.betLogs, (a, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_28, _toDisplayString(a.mday), 1),
                            _createElementVNode("td", _hoisted_29, _toDisplayString(a.count), 1),
                            _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.roundFixed2(a.sumPointed)), 1),
                            _createElementVNode("td", _hoisted_31, _toDisplayString(a.sumOrderPoint), 1),
                            _createElementVNode("td", _hoisted_32, _toDisplayString(a.sumxmOrderd), 1),
                            _createElementVNode("td", _hoisted_33, _toDisplayString(a.selfxmOrderd), 1),
                            _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.roundFixed2(
                                                (a.sumOrderPoint || 0) +
                                                    (a.selfxmOrderd || 0)
                                            )), 1),
                            _createElementVNode("td", _hoisted_35, [
                              _createElementVNode("span", {
                                class: "btn",
                                onClick: ($event: any) => (
                                                _ctx.OnClickLogsItem(a.mday || '')
                                            )
                              }, "详细", 8, _hoisted_36)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, "没有找到记录"))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.t('gameno')), 1),
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.t('table')), 1),
                _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.t('gameresult')), 1),
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.t('betType')), 1),
                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.t('betamount')), 1),
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.t('winOrLost')), 1),
                _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.t('bettime')), 1),
                _hoisted_47
              ]),
              _createElementVNode("div", _hoisted_48, [
                (_ctx.betLogDetails.length > 0)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_49, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.betLogDetails, (a, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_50, _toDisplayString(a.gameid), 1),
                            _createElementVNode("td", _hoisted_51, _toDisplayString(a.desk), 1),
                            _createElementVNode("td", _hoisted_52, _toDisplayString(a.jieguo), 1),
                            _createElementVNode("td", _hoisted_53, _toDisplayString(a.touzhu), 1),
                            _createElementVNode("td", _hoisted_54, _toDisplayString(a.pointed), 1),
                            _createElementVNode("td", _hoisted_55, _toDisplayString(a.orderpoint), 1),
                            _createElementVNode("td", _hoisted_56, _toDisplayString(a.betTime), 1),
                            _createElementVNode("td", _hoisted_57, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["btn", {
                                                'is-off': a.jieguo === ''
                                            }]),
                                onClick: ($event: any) => (_ctx.previewGame(`${a.gameid}`))
                              }, " 视频 ", 10, _hoisted_58)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_59, "没有找到记录"))
              ])
            ]))
      ])
    ]),
    (_ctx.showVideoPlayer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _createElementVNode("div", {
            class: "close-video-btn",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeVideo && _ctx.closeVideo(...args)))
          }),
          _createElementVNode("video", _hoisted_61, [
            _createElementVNode("source", {
              src: _ctx.videoSoure1,
              type: "video/mp4"
            }, null, 8, _hoisted_62),
            _createElementVNode("source", {
              src: _ctx.videoSoure2,
              type: "video/mp4"
            }, null, 8, _hoisted_63),
            _hoisted_64
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}